// MUI Imports
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// ** Icons Imports

// ** Third Party Imports
import { toast } from 'react-toastify'

const myToast = (promise: Promise<string>, successMessage?: string, successSubMessage?: string, errorMessage?: string) => {
  toast.promise(promise, {
    pending: {
      render() {
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', }}>
            <Typography variant='body1' sx={{ fontWeight: 600, fontSize: '0.8rem', }}>
              Loading...
            </Typography>
          </Box>
        )
      }
    },
    success: {
      render() {
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', }}>
            <Typography variant='body1' sx={{ fontWeight: 600, fontSize: '0.8rem', }}>
              {successMessage}
            </Typography>
            <Typography variant='subtitle2' sx={{ fontSize: '0.7rem', }}>
              {successSubMessage}
            </Typography>
          </Box>
        )
      }
    },
    error: {
      render({ data }) {
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', }}>
            <Typography variant='body1' sx={{ fontWeight: 600, fontSize: '0.8rem', }}>
              {errorMessage}
            </Typography>
            <Typography variant='subtitle2' sx={{ fontSize: '0.7rem', }}>
              {data as string}
            </Typography>
          </Box>
        )
      }
    }
  })
}

export default myToast
